import { FC, useState } from 'react';

import Button from 'components/common/ui-kit/Button';
import Checkbox from 'components/common/ui-kit/Checkbox';
import { FILTER_CONFIG } from 'config/filters';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import { createToast, hideModal } from 'redux/actions';
import { selectIsUserSupport } from 'redux/selectors';
import { setVisibleFilters } from 'redux/slices/staff/visibleFiltersSlice';

import './EditFilterModal.scss';

import TemplateModal from '../TemplateModal';

const formatFilterKey = (key: string): string => {
  const withSpaces = key.replace(/([A-Z])/g, ' $1').trim();
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1).toLowerCase();
};

const EditFilterModal: FC = () => {
  const dispatch = useAppDispatch();
  const isSupport = useAppSelector(selectIsUserSupport);
  const modalData = useAppSelector(state => state.modal.data);
  const page = modalData?.page;

  const currentFilters = useAppSelector(
    state => state.visibleFilters[page] ?? []
  );

  const [selected, setSelected] = useState<string[]>(currentFilters);

  if (!page) {
    console.error('EditFilterModal: page is required');
    return null;
  }

  const config = FILTER_CONFIG[page];

  if (!config) {
    console.error(`EditFilterModal: no config for page "${page}"`);
    return null;
  }

  const { allFilters = [], labels = {}, supportExcluded = [] } = config;

  const availableFilters = isSupport
    ? allFilters.filter(f => !supportExcluded.includes(f))
    : allFilters;

  const toggleFilter = (filterName: string) => {
    setSelected(prev =>
      prev.includes(filterName)
        ? prev.filter(f => f !== filterName)
        : [...prev, filterName]
    );
  };

  const handleSave = () => {
    if (selected.length === 0) {
      dispatch(createToast('Выберите хотя бы один фильтр', 'danger'));
      return;
    }
    dispatch(setVisibleFilters({ page, filters: selected }));
    dispatch(hideModal());
  };

  const handleReset = () => {
    setSelected([]);
  };

  const handleSelectAll = () => {
    setSelected(availableFilters);
  };

  return (
    <TemplateModal title="Фильтры">
      <div className="filter-modal">
        <div className="button-group__up">
          <Button size="micro" onClick={handleReset}>
            Сбросить все
          </Button>
          <Button size="micro" onClick={handleSelectAll}>
            Выбрать все
          </Button>
        </div>
        <div className="filters">
          {availableFilters.map(filterName => (
            <div key={filterName}>
              <label>
                <Checkbox
                  checked={selected.includes(filterName)}
                  onChange={() => toggleFilter(filterName)}
                  text={labels[filterName] || formatFilterKey(filterName)}
                />
              </label>
            </div>
          ))}
        </div>
        <div className="button-group__down">
          <Button onClick={handleSave} theme="success">
            Сохранить
          </Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default EditFilterModal;
